'use strict';

namespace Core {

    class CancellationInformation {
        readonly amendableUntil: Date;
        readonly freeCancellationUntil: Date;
        readonly isPayAtHotel: boolean;
        readonly nonRefundable: boolean;

        constructor(nonRefundable: boolean,
                    refundableCutOff: Date | null,
                    cancellationCutOff: Date | null,
                    payAtHotel: boolean) {

            if (nonRefundable === true) {
                this.nonRefundable = nonRefundable;
            } else if (refundableCutOff != null) {
                this.amendableUntil = refundableCutOff;
            } else if (cancellationCutOff != null) {
                this.freeCancellationUntil = cancellationCutOff;
            }

            this.isPayAtHotel = payAtHotel;
        }
    }

    class HotelStaySummaryRoom {
        readonly boardDescription: string;
        readonly cancellationInfo: CancellationInformation;
        readonly roomDescription: string;
        quantity: number = 1;

        constructor(quantity: number,
                    roomDescription: string,
                    boardDescription: string,
                    cancellationPolicy: CancellationInformation) {
            this.quantity = quantity;
            this.roomDescription = roomDescription;
            this.boardDescription = boardDescription;
            this.cancellationInfo = cancellationPolicy;
        }

    }

    class HotelStaySummary {

        atolAvailable: boolean;
        hotel: any;
        occupancy: any;
        groupRooms:boolean;
        rooms: HotelStaySummaryRoom[];




        constructor(
            public $scope: any,
            private modalService: any,
            private basketService: any
        ) {

            this.$scope.$watch('hss.hotel.Details.BookedItems', v => {
                if (!_.isArray(v)) {
                    return;
                }
                // concatenate rooms which have matching descriptions, board types and cancellation messages
                this.rooms = [];

                _.each(v, (bi: any) => {
                    let room: string = bi.RoomDescription;
                    let board: string = bi.BoardDescription;

                    const info = new CancellationInformation(bi.NonRefundable,
                        bi.RefundableCutOffDate,this.hotel.FreeCancellationCutOffDate,bi.IsPayAtHotel);

                    if(this.groupRooms === false){
                        this.rooms.push(new HotelStaySummaryRoom(1, room, board, info));
                    } else {
                        let match: HotelStaySummaryRoom = _.find(this.rooms, (r) => {
                        return r.roomDescription === room
                                && r.boardDescription === board
                                && _.isEqual(r.cancellationInfo, info);
                        });
                        if (match) {
                            match.quantity += 1;
                        } else {
                            this.rooms.push(new HotelStaySummaryRoom(1, room, board, info));
                        }
                    }
                });
            });

        }

        public showModal(url) {
            this.modalService.launch(url);
        }

        public changeHotel() {
            this.basketService.changeJourneyUrl(20);
        }

    }

    angular
        .module('core')
        .directive('hotelStaySummary', (): ng.IDirective => {

        return {
            scope: {},
            controller: HotelStaySummary,
            controllerAs: 'hss',
            replace: true,
            bindToController: {
                atolAvailable: '=',
                hotel: '=',
                occupancy: '=',
                groupRooms: '='
            },
            templateUrl: (element, attr) => {
                if(attr.templateVersion){
                    return 'partials/booking/template?name=HotelStaySummary&version='
                    + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=HotelStaySummary';
            }
        };

    });

}
